module.exports = __webpack_public_path__ + "static/media/earthlovelife_brand_banner.332438e3.jpg";